import { useState } from "react"
import Button, {
  type ButtonProps,
} from "@/v2-backoffice-client/components/button"
import LicenseFeatureGroupUpsertDialog from "@/v2-backoffice-client/license/featureGroup/LicenseFeatureGroupUpsertDialog"

export type LicenseFeatureGroupCreateButtonProps = ButtonProps

// The page header's New Package action (same placement contract as the
// customers page's Create customer), shown while the Packages tab is active.
// Same dialog as the row menu's edit, without a package.
function LicenseFeatureGroupCreateButton(
  props: LicenseFeatureGroupCreateButtonProps,
) {
  const { onClick, ...buttonProps } = props
  const [isCreateOpen, setIsCreateOpen] = useState(false)

  return (
    <>
      <Button
        variant="primary"
        size="tiny"
        iconSrc="plus"
        iconSize={10}
        data-feature-code="UI_BackofficeFeatureGroup_Toolbar_New"
        onClick={(e) => {
          setIsCreateOpen(true)
          onClick?.(e)
        }}
        {...buttonProps}
      >
        New Package
      </Button>

      <LicenseFeatureGroupUpsertDialog
        open={isCreateOpen}
        onOpenChange={setIsCreateOpen}
      />
    </>
  )
}

export default LicenseFeatureGroupCreateButton
